import { Component, OnDestroy, OnInit } from '@angular/core';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
// import { NavbarOption, NavItem } from '@drx/uilib/navbar';
import { Emittable, Emitter } from '@ngxs-labs/emitter';
import { IServerModelState, LoadModels } from './secure/states/iserver-model.state';
import { IServerObjectTypeState, LoadObjectTypes } from './secure/states/iserver-objecttypes.state';
import { Subject, filter, takeUntil, tap } from 'rxjs';
import {
  AuthenticationResult,
  EventMessage,
  EventType,
  InteractionStatus,
} from '@azure/msal-browser';
import { environment } from '../environments/environment';
import { Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { Store } from '@ngxs/store';

interface NavbarItem {
  text: string;
  link: string;
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatButtonModule,
    MatMenuModule,
    MatToolbarModule,
    RouterModule,
    RouterOutlet,
    MatIconModule,
  ],
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'iServer365UtilApp';
  loggedIn = false;
  triggerMenu = false;

  private readonly _destroying$ = new Subject<null>();

  // navbarOption: NavbarOption = {
  //   appName: 'Utility App',
  //   icon: 'data:image/png;base64,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',
  //   hasShadow: true,
  // };

  readonly navItems: NavbarItem[] = [
    {
      text: 'Tasks',
      link: '/secure/tasks',
    },
    {
      text: 'Chat',
      link: '/secure/chat',
    },
  ];

  constructor(
    private msalBroadcastService: MsalBroadcastService,
    private authService: MsalService,
    private store: Store,
    private router: Router
  ) { }

  ngOnDestroy(): void {
    this._destroying$.next(null);
    this._destroying$.complete();
  }
  ngOnInit() {

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.updateFavicon(event.urlAfterRedirects);
      }
    });

    this.msalBroadcastService.msalSubject$
      .pipe(
        filter(
          (msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS
        ),
        takeUntil(this._destroying$)
      )
      .subscribe((result) => {
        const payload = result.payload as AuthenticationResult;
        this.authService.instance.setActiveAccount(payload.account);
        this.loggedIn = true;
        this.loadData();
      });

    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None)
      )
      .subscribe(() => {
        this.loggedIn = this.authService.instance.getAllAccounts().length > 0;
        if (this.loggedIn) {
          this.loadData();
        }
      });
  }

  private loadData() {
    this.store.dispatch(new LoadModels());
    this.store.dispatch(new LoadObjectTypes());
  }

  login() {
    this.authService.loginRedirect({
      authority: environment.authority,
      scopes: environment.iServerScopes,
      redirectUri: environment.redirectUri,
    });
  }

  logout() {
    this.authService.logout();
  }
  toggleMenu() {
    this.triggerMenu = !this.triggerMenu;
  }


  private updateFavicon(url: string): void {
    const favicon = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
    if (!favicon) return;

    if (url.startsWith('/secure/chat')) {
      favicon.href = 'dream.ico';
    } else {
      favicon.href = 'favicon.ico';
    }
  }

}
